<template>
  <div class="card-list-body">
    <div
      v-for="item in list"
      :key="item.cardId"
      class="list-item"
    >
      <card-video
        v-stlog="{playVideo: item}"
        @click="playVideo"
        :feed="item"
      />
    </div>
    <dialog-video v-model="visible" />
  </div>
</template>

<script>
import DialogVideo from '@/components/Dialog/DialogVideo';
import CardVideo from '@/components/Card/CardVideo';

import EventBus from '@/common/Base';

export default {
  name: 'VideoList',

  components: {
    CardVideo,
    DialogVideo
  },

  props: {
    list: {
      type: Array,
      default: () => ([])
    }
  },
  data() {
    return {
      visible: false
    };
  },
  methods: {
    playVideo(feed) {
      EventBus.$emit('videoShow', feed);
      this.visible = true;
    }
  }
};
</script>
